var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast",attrs:{"name":"toast"}},[_c('span',[_vm._v("공감해 주셔서 감사합니다!")]),_vm._v(" "),_c('img',{staticStyle:{"width":"22px","cursor":"pointer"},attrs:{"src":require("../../../assets/close_white.png")},on:{"click":_vm.close}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54fb4bdb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/pc_uncomfortable/Toast.vue
// module id = null
// module chunks = 